import { render } from "./PropertyFormLayout.vue?vue&type=template&id=62137626&scoped=true&ts=true"
import script from "./PropertyFormLayout.vue?vue&type=script&lang=ts"
export * from "./PropertyFormLayout.vue?vue&type=script&lang=ts"

import "./PropertyFormLayout.vue?vue&type=style&index=0&id=62137626&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62137626"]])

export default __exports__